import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
      border-right: ${displayState?.hideBorder ? '' : '1px solid #C7EFDA'};
      padding: 5px 10px;
      height: 100%;
      width: ${displayState?.width ?? ''};
  `}
`;

export default Wrapper(template);